export interface Toast {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export function useToast() {
  const toast = (toastData: Toast) => {
    if (toastData.variant === 'destructive') {
      alert(`Error: ${toastData.title}\n${toastData.description || ''}`);
    } else {
      alert(`${toastData.title}\n${toastData.description || ''}`);
    }
  };

  return { toast };
}
